export var colors = ['N80', 'N900'];
export var placeholderColors = ['N80', 'N100'];
export var prependColors = ['N80', 'N100'];
export var themes = ['b2c', 'b2b'];
export var underlineColors = ['N40', 'N50'];
export var weights = ['bold'];